<template>
  <v-row justify="center" class="py-5">
    <v-btn color="primary" @click="activateAlertDialog = true" elevation="0">
      {{$t('bounties.redeemBountyDetailsActivate')}}
    </v-btn>

    <v-dialog v-model="successActivateDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="title">{{ $t('bounties.voucherModalSuccessTitle') }}</v-card-title>
        <v-card-text>
          <div class="body-1" v-html="$t('bounties.voucherModalSuccessText', {bountyName: bounty.name})"></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onFinishPressed">{{ $t('bounties.voucherModalSuccessButtonText') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="errorActivateDialog.show" max-width="320">
      <v-card>
        <v-card-title class="headline">{{errorActivateDialog.title}}</v-card-title>

        <v-card-text>
          <div class="caption">{{errorActivateDialog.description}}</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="errorActivateDialog.show = false">{{ $t('bounties.voucherModalErrorActivateButtonText') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="activateAlertDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{ $t('bounties.voucherModalActivateAlertTitle')}}</v-card-title>

        <v-card-text>
          <div>{{ $t('bounties.voucherModalActivateAlertText') }}</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="activateAlertDialog = false">{{ $t('bounties.voucherModalActivateAlertCancelButton') }}</v-btn>
          <v-btn color="primary" text @click="onActivate" :loading="activateLoading">{{ $t('bounties.voucherModalActivateAlertActivateButton') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>

  import {mdiCartPlus} from '@mdi/js';
  import _ from 'lodash';
  import Vue from 'vue';
  import {BASE_API_URL} from '@/store';

  export default {
    name: 'ActivateBountyButton',
    props: ['bounty'],
    data() {
      return {
        icons: {
          mdiCartPlus
        },
        activateAlertDialog: false,
        successActivateDialog: false,
        errorActivateDialog: {
          show: false,
          title: this.$t('bounties.voucherModalErrorActivateTitle'),
          description: ''
        },
        activateLoading: false
      }
    },
    computed: {
    },
    methods: {
      async onActivate() {
        this.activateLoading = true;

        const bodyData = {
          bounty_id: this.bounty.id,
        };

        try {
          let response = await Vue.axios.post(`${BASE_API_URL}/api/v1/clients/${this.$store.state.client_id}/bounties/activate/`, JSON.stringify(bodyData));
          if (response.data.success) {
            this.successActivateDialog = true;
          } else {
            this.errorActivateDialog.show = true;
            if (_.has(response.data, 'code') && response.data.code === 'BOUNTY_NOT_ACTIVATED') {
              this.errorActivateDialog.description = this.$t('bounties.voucherModalErrorActivateBountyNotActivated');
            } else {
              this.errorActivateDialog.description = this.$t('bounties.voucherModalErrorActivateBountyInvalid');
            }
          }
        } catch (error) {
          this.errorActivateDialog.show = true;
          this.errorActivateDialog.description = this.$t('bounties.voucherModalErrorActivateDefaultDescription');
          console.log('Error activating bounty: ', error);
        } finally {
          this.activateLoading = false;
          this.activateAlertDialog = false;
        }
      },
      onFinishPressed() {
        this.successActivateDialog = false;
        location.reload();
      }
    }
  }
</script>
